import styled from 'styled-components'

import LogoImg from '../../resources/img/logo.png'
import { colors } from '../../constants'
import { AppUtils } from '../../utils'

const Wrapper = styled.div`
    position: relative;
`

const Img = styled.img`
    border-style: none;
    border-radius: 5px;
    width: 160px;
    vertical-align: middle;
`

const BetaRibbon = styled.div`
    color: ${colors.bluelightest};
    border-radius: 0 0 5px 5px;
    background: ${colors.bluedark};
    bottom: -8px;
    font-weight: bold;
    letter-spacing: 1px;
    position: absolute;
    text-align: center;
    width: 100%;
`

const Logo = (props) => (
    <Wrapper>
        {AppUtils.isStaging() && <BetaRibbon>Staging</BetaRibbon>}
        <Img src={LogoImg} alt="Volume" {...props} />
    </Wrapper>
)

export default Logo
